<template>
  <v-card class="docs serviceCZN">
    <v-form ref="form" class="mx-2" lazy-validation>
    <v-card-title>
      <div class="text-h5 text-center">Создание справочника</div>
    </v-card-title>

    <table class="docs-table">
      <tbody>
      <tr>
        <td><v-text-field :rules="required" placeholder="Название справочника" required v-model="localDict.name"></v-text-field></td><td></td>
      </tr>
      <tr><td>Значения</td><td></td></tr>
      <tr v-for="(value, valueIndex) in localDict.values" :key="'val_'+valueIndex">
        <td>
          <v-text-field :rules="required" v-model="localDict.values[valueIndex]"></v-text-field>
        </td><td><v-icon @click="removeValue(valueIndex)">mdi-trash-can</v-icon></td>
      </tr>
      <tr>
        <a href="#" @click.prevent="addValue()">Добавить значение</a>
      </tr>
      </tbody>
    </table>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          class="btn btn-outline"
          text
          @click="$emit('close', dict)"
      >
        Закрыть
      </v-btn>
      <v-btn
          class="btn btn-primary"
          @click="submit()"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {uuidv4} from "@/modules/services";

export default {
  name: 'EditDialog',
  props: {
    config: Object,
    dict: Object
  },

  data: () => ({
    localDict: {name: '', values: []},

    required: [
      v => !!v || 'Заполните поле',
    ]
  }),
  methods: {
    async submit() {
      if(!this.$refs.form.validate()){
        return
      }
      if(this.dict){
        this.dict.name = this.localDict.name
        this.dict.values = this.localDict.values
      } else {
        if(!this.config.dicts) {
          this.config.dicts = []
        }
        this.config.dicts.push(this.localDict)
      }
      this.$emit('close', this.localDict)
    },

    addValue(){
      this.localDict.values.push('')
    },

    removeValue(valueIndex){
      this.localDict.values.splice(valueIndex, 1)
    }
  },
  beforeMount() {
    console.log(this.dict)
    if(this.dict) {
      this.localDict = JSON.parse(JSON.stringify(this.dict))
    }
    else {
      this.localDict.id = 'dict_'+uuidv4()
    }
  }
}
</script>


